module.exports = "https://coursera_assets.s3.amazonaws.com/images/adc03df7469cca0efef8ed0981fb8dea.png";